import { useLocale } from "@acto/web-common/locales";
import { EMPTY_MEETING_PREP_ENTRY, getMeetingPrepCacheKey, useMeetingPrepStore } from "./meetingPrepStore";

export function useMeetingPrepEntry(clientExternalReference?: string) {
  const { locale } = useLocale();
  const cacheKey = clientExternalReference ? getMeetingPrepCacheKey(clientExternalReference, locale) : undefined;

  return useMeetingPrepStore((state) =>
    cacheKey ? (state.byKey.get(cacheKey) ?? EMPTY_MEETING_PREP_ENTRY) : EMPTY_MEETING_PREP_ENTRY,
  );
}
